import React from "react";
import moment from "moment";
import { bindActionCreators } from "redux";
import connect from "react-redux/es/connect/connect";
import { Pagination } from "../../../controls";
import { DataTable } from "../../../common";
import { AiFillEye } from "react-icons/ai";
import LoaderView from "./LoaderView";

const All = ({
  userDocument,
  downloadFile,

  userWfhList,
  rowsPerPage,
  rowCount,
  currentPage,
  getUserWfhList,
  getDocument,
  getUserWfh,
  userWfhListSuccess,
  changingYear,
}) => {
  // console.log("changingyr", changingYear);
  const columns = [
    {
      name: "Start Date",
      center: true,
      grow: 4,
      cell: (row) => (
        <span>{moment(new Date(row.startDate)).format("DD/MM/YYYY")}</span>
      ),
    },
    {
      name: "End Date",
      center: true,
      grow: 4,
      cell: (row) => (
        <span>{moment(new Date(row.endDate)).format("DD/MM/YYYY")}</span>
      ),
    },
    {
      name: "Status",
      center: true,
      grow: 4,
      cell: (row) => {
        if (row.status === 0) {
          return (
            <span className="badge bg-warning-transparent">
              Pending Approval
            </span>
          );
        }
        if (row.status === 1) {
          return <span className="badge bg-success-transparent">Approved</span>;
        }
        if (row.status === -1) {
          return <span className="badge bg-danger-transparent">Rejected</span>;
        }
        if (row.status === -2) {
          return <span className="badge bg-cancel-transparent">Cancelled</span>;
        }
      },
    },
    // {
    //   name: "Type",
    //   selector: "masterLeaveType",
    //   center: true,
    //   grow: 4,
    // },
    {
      name: "FD/1H/2H",
      selector: "leaveSubType",
      center: true,
      grow: 4,
    },
    // {
    //   name: 'Applier',
    //   selector: 'userId[0].firstName',
    //   center: true,
    //   grow: 4,
    // },
    {
      name: "Employee",
      center: true,
      grow: 4,
      cell: (row) => (
        <span>
          {row.userId[0].firstName} {row.userId[0].lastName.slice(0, 1)}
        </span>
      ),
    },
    {
      name: "Detail",
      center: true,
      minWidth: "80px",
      grow: 2,
      cell: (row) => (
        <div className="d-flex">
          <AiFillEye
            className="view"
            size={18}
            onClick={() => {
              getUserWfh(row._id);

              if (row.attachementDocumentId) {
                // console.log("roe", row);
                getDocument(
                  row.employeeId[0],
                  true,
                  false,
                  row.attachementDocumentId
                );
              }
              // handleViewOpen()
            }}
          />
        </div>
      ),
    },
  ];

  const onChangePage = (currentPage) => {
    getUserWfhList(
      currentPage,
      {
        year: changingYear,
      },
      false
    );
  };
  if (userWfhListSuccess === false) {
    return <LoaderView />;
  } else {
    return (
      <>
        <div className="table_content px-2 attendance_table pb-3">
          <DataTable
            data={userWfhList}
            columns={columns}
            pagination={false}
            paginationPerPage={5}
            paginationServer={false}
          />
        </div>

        {userWfhList.length > 0 ? (
          <div className="margin_x mt-2 me-3 mb-3 d-flex justify-content-end">
            <Pagination
              rowsPerPage={rowsPerPage}
              rowCount={rowCount}
              onChangePage={onChangePage}
              currentPage={currentPage}
            />
          </div>
        ) : null}
      </>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    userWfhList: state.employeeWfhReducer.userWfhList,
    page: state.employeeWfhReducer.page,
    userWfhListSuccess: state.employeeWfhReducer.userWfhListSuccess,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      // getUser: getUser,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(All);
